/** Viewports at or below this width use the slide-out sidebar drawer. */
export const SIDEBAR_DRAWER_MAX_WIDTH = 1024;
